var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasonry = function SvgMasonry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 12.526a.98.98 0 0 1-.975.98h-7.8a.977.977 0 0 1-.975-.98V1.736a.98.98 0 0 1 .976-.98l7.8.013a.98.98 0 0 1 .974.98zm12.746-5.982a.97.97 0 0 1-.975.962h-7.8a.97.97 0 0 1-.975-.962V1.731a.97.97 0 0 1 .973-.962l7.8-.013a.97.97 0 0 1 .977.962zM10.5 22.291a.97.97 0 0 1-.977.965l-7.8-.013a.97.97 0 0 1-.973-.964V17.47a.97.97 0 0 1 .975-.964h7.8a.97.97 0 0 1 .975.964zm3.972.965a.98.98 0 0 1-.976-.981V11.487a.98.98 0 0 1 .975-.981h7.8a.98.98 0 0 1 .975.981v10.775a.98.98 0 0 1-.974.981z"
  })));
};
export default SvgMasonry;